import { connect } from 'react-redux';
import ContactFormComponent from '../component/ContactFormComponent';
import { sendMessage } from '../actions/ContactAction';

const mapStateToProps = (state) => ({
    submitting: state.contact.submitting,
    submitted: state.contact.submitted,
    userId: state.profile.user.userId,
});

const mapDispatchToProps = (dispatch) => ({
    sendMessage: (data) => {
        dispatch(sendMessage(data));
    },
});

const ContactFormContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ContactFormComponent);

export default ContactFormContainer;
